import React, { useState } from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter, Input, Button } from '@material-tailwind/react';

export default function BlacklistModal({ open = false, onClose = () => { }, onConfirm = () => { }, driver = null, action = 'blacklist', error = '' }) {
    const [reason, setReason] = useState('');
    const title = action === 'blacklist' ? 'Blacklist Driver' : 'Unblacklist Driver';

    const handleConfirm = () => {
        onConfirm({ reason });
        setReason('');
    };

    return (
        <Dialog open={open} handler={onClose} size="sm">
            <DialogHeader>{title}</DialogHeader>
            <DialogBody divider>
                <div className="space-y-2">
                    {error && (
                        <div className="text-sm text-red-700 bg-red-50 border border-red-100 px-3 py-2 rounded">
                            {error}
                        </div>
                    )}
                    <div className="text-sm text-gray-600">Driver: <strong>{driver?.name || driver?.id || ''}</strong></div>
                    <div className="text-sm text-gray-700">Provide a reason (optional):</div>
                    <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason" />
                </div>
            </DialogBody>
            <DialogFooter>
                <Button variant="text" color="gray" onClick={onClose}>Cancel</Button>
                <Button variant="gradient" color="red" onClick={handleConfirm}>{action === 'blacklist' ? 'Blacklist' : 'Unblacklist'}</Button>
            </DialogFooter>
        </Dialog>
    );
}
